import 'react-app-polyfill/ie11';
import 'core-js/features/array/find-index';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/object/entries';
import 'core-js/features/object/values';
import 'core-js/features/set';
import 'core-js/features/string/starts-with';
import 'core-js/features/url-search-params';

if (!window.AbortController) {
  require('abortcontroller-polyfill/dist/polyfill-patch-fetch');
}
